import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { AuthCard, FormError, errorMessage } from "../components/AuthCard";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!email.trim()) {
      setError("Enter your email address.");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      setSent((await api.forgotPassword(email)).message);
    } catch (err) {
      setError(errorMessage(err, "Something went wrong. Try again."));
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <AuthCard title="Check your email" footer={<Link to="/login">Back to sign in</Link>}>
        <p className="notice" role="status">
          {sent}
        </p>
        <p className="muted small">The link expires in an hour. Didn't get it? Check your spam folder, or ask again.</p>
        <button className="btn btn-block" onClick={() => setSent(null)}>
          Send another link
        </button>
      </AuthCard>
    );
  }

  return (
    <AuthCard
      title="Forgot your password?"
      subtitle="Enter your account's email and we'll send you a link to choose a new password."
      onSubmit={onSubmit}
      footer={
        <>
          Remembered it? <Link to="/login">Sign in</Link>
        </>
      }
    >
      <label>
        Email
        <input
          type="email"
          autoComplete="email"
          autoCapitalize="none"
          spellCheck={false}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
        />
      </label>
      <FormError message={error} />
      <button className="btn btn-primary btn-block" disabled={busy}>
        {busy ? "Sending…" : "Send reset link"}
      </button>
    </AuthCard>
  );
}
